import { AbstractControl } from '@angular/forms';
import { FrequentFlyerNumberInput } from '@app/generated/graphql';

export const frequentFlyerNumbersValidator = (control: AbstractControl) => {
  const { value } = control;

  if (!value || value.length === 0) {
    return null;
  }

  const hasInvalid = (value as FrequentFlyerNumberInput[]).find((number) => {
    if (!number) return null;

    const keys: (keyof FrequentFlyerNumberInput)[] = ['airlineId', 'number'];

    return keys.some((key: keyof FrequentFlyerNumberInput) => !number[key]);
  });

  if (hasInvalid) {
    return { 'frequent-flyer-numbers': true };
  }

  return null;
};
